export default __webpack_public_path__ + "static/media/120.d3b3e983.jpg";